const TechIcon = ({ iconURL }) => {
    return <img src={iconURL} />
}

export default TechIcon;